import { createReducer } from 'typesafe-actions';

import {
  TAllBeneficiariesAction,
  AllBeneficiariesActionTypes,
  IAllBeneficiariesState,
} from '@/features/beneficiaries/store/types/all-beneficiaries.types';

const initialState: IAllBeneficiariesState = {
  beneficiaries: [],
  meta: {},
  isLoading: false,
};

export const allBeneficiariesReducer = createReducer<IAllBeneficiariesState, TAllBeneficiariesAction>(initialState)
  .handleType(AllBeneficiariesActionTypes.SEARCH_ALL_BENEFICIARIES, (state) => ({
    ...state,
    error: undefined,
    isLoading: true,
  }))

  .handleType(AllBeneficiariesActionTypes.SEARCH_ALL_BENEFICIARIES_SUCCESS, (state, action) => ({
    ...state,
    beneficiaries: action.beneficiaries,
    meta: action.meta,
    isLoading: false,
    error: undefined,
  }))

  .handleType(AllBeneficiariesActionTypes.SEARCH_ALL_BENEFICIARIES_FAIL, (state, action) => ({
    ...state,
    error: action.error,
    isLoading: false,
  }));
